import { fetchVaultPages, upsertVaultPage } from '@/lib/librarian/api';
import type { KnowledgeBaseVault } from '@/lib/librarian/types';

export async function updateIndexPage(vault: KnowledgeBaseVault) {
  const pages = await fetchVaultPages(vault.id);
  const rootPages = pages.filter((page) => !page.path.includes('/')).sort((a, b) => a.path.localeCompare(b.path));
  const grouped = new Map<string, typeof pages>();

  for (const page of pages.filter((entry) => entry.path.includes('/'))) {
    const folder = page.path.split('/')[0];
    grouped.set(folder, [...(grouped.get(folder) ?? []), page]);
  }

  const sections = Array.from(grouped.entries())
    .sort(([a], [b]) => a.localeCompare(b))
    .map(([folder, folderPages]) => {
      const list = folderPages
        .sort((a, b) => a.path.localeCompare(b.path))
        .map((page) => `- [${page.title}](${page.path}) · ${page.page_type}`)
        .join('\n');

      return `## ${folder}\n${list}`;
    })
    .join('\n\n');

  const content = [
    '# Librarian Vault Index',
    '',
    `Updated: ${new Date().toISOString()}`,
    '',
    '## Root Pages',
    ...rootPages.map((page) => `- [${page.title}](${page.path}) · ${page.page_type}`),
    '',
    sections,
  ]
    .filter(Boolean)
    .join('\n');

  return upsertVaultPage({
    vaultId: vault.id,
    path: 'index.md',
    title: 'Vault Index',
    pageType: 'index',
    contentMarkdown: content,
    summary: 'Top-level map of the librarian vault.',
    metadata: { generatedBy: 'librarian', pageCount: pages.length },
  });
}
